import { ChangeDetectorRef, Directive, Injector, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { HttpOptions, PaginationDataBaseDto, HttpInterface, Status } from '@core';
import { BtnFooter } from '@core/service/model/footer.dto';
import { LocalStoreEnum } from '@shared/models/enum/local-store.enum';
import { Observable } from 'rxjs';
import { finalize, map, takeUntil } from 'rxjs/operators';
import { DformPaginationPlusComponent } from '../dform-pagination-plus/component/dform-pagination-plus.component';
import { ComponentAbstract } from './component.abstract';

/**
 * @author bondm
 * ComponentBase Xử lý các func chung và common của hệ thống
 */
@Directive()
export abstract class ComponentBaseAbstract extends ComponentAbstract {
    public pageSize = 10;
    public pageIndex = 0;
    public totalItem = 0;
    public hasDataSource = false;
    public baseListData;
    protected router: Router;
    protected route: ActivatedRoute;
    protected cdRef: ChangeDetectorRef;
    public queryParams: Params;
    protected dialog: MatDialog;
    public dataSource: MatTableDataSource<any>;
    public isAdmin: boolean;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('pagePage') dformPagination: DformPaginationPlusComponent;
    pageEvent: PageEvent = new PageEvent();
    public opstions: HttpOptions;
    constructor(protected injector: Injector) {
        super(injector);
        this.router = injector.get(Router);
        this.route = injector.get(ActivatedRoute);
        this.dialog = injector.get(MatDialog);
        this.cdRef = injector.get(ChangeDetectorRef);
        this.getRoleUser()
    }

    protected abstract componentInit(): void;

    protected saveData(): void { }

    initData() {
        this.route.queryParams.subscribe((queryParams: Params) => {
            try {
                this.parseParams(queryParams);
                this.componentInit();
            } catch (e) {
                this.logger.error('Error', e);
                this.goTo404();
            }
        });
    }

    /**
     * Xử lý lấy role user đang nhập
     */
    private getRoleUser() {
        // Lấy thông tin quyền user
        const userInfo = this.localStore.getData(LocalStoreEnum.User_Infor);
        const listAdmin = userInfo.authorities.filter(x => x.toUpperCase() === 'ADMIN');
        this.isAdmin = listAdmin.length > 0;
    }

    /**
     * Xử lý check change data
     */
    canDeactivate(): Observable<boolean> | boolean {
        if (!this.jsonObjEqual(this.baseData, this.form.getRawValue()) && this.form.dirty) {
            return this.dialogService.confirmChange({
                title: 'dialog.notification',
                innerHTML: 'Dữ liệu màn hình đã được thay đổi.<br> Bạn có muốn rời khỏi trang?'
            }).pipe(
                takeUntil(this.ngUnsubscribe),
                map(res => res)
            );
        }
        return true;
    }

    // NAVIGATION
    getRouter() {
        return this.router;
    }

    private parseParams(queryParams: Params) {
        this.queryParams = queryParams;
    }

    /**
     * Xử lý chuyển màn hinh
     * @param state
     * @param params
     * @param replaceUrl
     * @param relativeTo
     */
    goTo(state: string, params?: any, replaceUrl?: boolean, relativeTo?: ActivatedRoute) {
        replaceUrl = replaceUrl == null ? false : replaceUrl;
        this.router.navigate([state], { queryParams: params, relativeTo, replaceUrl });
    }

    reloadState() {
        // To do
        this.form.reset();
    }

    goTo404() {
        this.router.navigate(['error'], { replaceUrl: true });
    }

    reloadData() {
        // DO NOTHING
    }

    refresh() {
        this.reloadState();
    }

    /**
     * Xử lý action quay lại
     */
    back() {
        window.history.back();
    }

    /**
     * @author PHUONGPV
     * Auto scroll to control validate false
     */
    scrollIntoViewErrorValidate() {
        const element = document.querySelector('.error');
        if (element) {
            element.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    };


    /**
     * @param reloadData func load lại thông tin màn hình
     * @param _this
     */
    messageDialog(reloadData, _this: any, message: string = 'lbl.update_success') {
        this.dialogService.success({
            title: 'dialog.notification',
            message: message,
        }, (result: any) => {
            if (result) {
                reloadData.call(_this);
            }
        });
    }

    /**
     * Load data cho grid từ this.opstions được gán giá trị trước khi call function này
     */
    loadDataSourceTable<T>() {
        this.indicator.showActivityIndicator();
        this.dataSource = new MatTableDataSource([]);
        this.httpClient.get(this.opstions).pipe(
            takeUntil(this.ngUnsubscribe),
            finalize(() => this.indicator.hideActivityIndicator()),
            map((response: PaginationDataBaseDto<T>) => {
                return response;
            })
        ).subscribe((item) => {
            // Gọi API thành công và có data trả về
            if (item.code === 0 && item.data.totalCount > 0) {
                this.hasDataSource = true;
                const page = this.pageIndex * this.pageSize;
                this.baseListData = item.data?.items?.map((obj: any, index) => { obj.stt = page + index + 1; return obj; });
                this.dataSource = new MatTableDataSource(this.baseListData);
                this.totalItem = item.data.totalCount;
            } else {
                this.hasDataSource = false;
            }
            this.dataSource.sort = this.sort;
        });
    }

    /**
    * Load data table
    */
    loadDataSourceTableLocal() {
        this.dataSource = new MatTableDataSource([]);
        this.indicator.showActivityIndicator();
        this.httpClient.get(this.opstions).pipe(
            takeUntil(this.ngUnsubscribe),
            finalize(() => this.indicator.hideActivityIndicator()),
            map((response: HttpInterface<any[]>) => {
                return response;
            })
        ).subscribe((item) => {
            // Gọi API thành công và có data trả về
            if (item.code === Status.SUCCESS) {
                this.hasDataSource = true;
                this.baseListData = item.data.map((obj, index) => { obj.stt = index + 1; return obj; });
                this.dataSource = new MatTableDataSource(this.baseListData);
                if (!this.dataSource.paginator && this.dformPagination) {
                    this.dataSource.paginator = this.dformPagination.paginator;
                }
                this.totalItem = item.data.length;
            } else {
                this.hasDataSource = false;
            }
            this.dataSource.sort = this.sort;
        });
    }

    /**
     * Event load data phân trang
     */
    chanePageIndex($event) {
        this.pageSize = $event.pageSize;
        this.pageIndex = $event.pageIndex;
        const optionsData = this.cloneData(this.opstions);
        optionsData.params.page = this.pageIndex;
        optionsData.params.size = this.pageSize;
        this.opstions = optionsData;
        this.loadDataSourceTable();
        if (!this.dataSource.paginator && this.dformPagination) {
            this.dataSource.paginator = this.dformPagination.paginator;
        }
    }

    chanePageIndexLocal($event){
        this.dataSource.paginator.pageIndex =  $event.pageIndex;
      }

    reloadTableLocal($data) {
        this.dataSource = new MatTableDataSource($data);
        if (!this.dataSource.paginator && this.dformPagination) {
            this.dataSource.paginator = this.dformPagination.paginator;
        }
        this.totalItem = this.dataSource.data.length;
        this.hasDataSource = this.totalItem > 0;
        this.dataSource.sort = this.sort;
    }
}
